window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.ce-topics-btn-all').length) {
    import('./_themenfelder.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}